import { c as _c } from "react/compiler-runtime";
import React, { forwardRef } from 'react';
import { StyledToggle, StyledThumb } from './styles';
import { type ToggleProps } from './types';
import { CheckIcon } from '../icons/CheckIcon';
const Toggle = forwardRef<HTMLButtonElement, ToggleProps>((t0, ref) => {
  const $ = _c(14);
  let checked;
  let defaultChecked;
  let onChange;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      disabled: t1,
      onChange,
      checked,
      defaultChecked,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = checked;
    $[2] = defaultChecked;
    $[3] = onChange;
    $[4] = props;
    $[5] = t1;
  } else {
    checked = $[1];
    defaultChecked = $[2];
    onChange = $[3];
    props = $[4];
    t1 = $[5];
  }
  const disabled = t1 === undefined ? false : t1;
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <StyledThumb><CheckIcon /></StyledThumb>;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== checked || $[8] !== defaultChecked || $[9] !== disabled || $[10] !== onChange || $[11] !== props || $[12] !== ref) {
    t3 = <StyledToggle checkedIcon={t2} disabled={disabled} onChange={onChange} checked={checked} defaultChecked={defaultChecked} {...props} ref={ref} />;
    $[7] = checked;
    $[8] = defaultChecked;
    $[9] = disabled;
    $[10] = onChange;
    $[11] = props;
    $[12] = ref;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
});
export default Toggle;
export { Toggle };